import React from 'react';
import Script from 'react-load-script';

interface GmScriptLoaderProps {
	attributes?: object;
	onCreate?(): void;
	onError?(): void;
	onLoad?(): void;
}

/**
 * A script loader component for the Google Maps JS API with event callbacks
 * @param props the props of type GmScriptLoaderProps
 */
export const GmScriptLoader: React.FC<GmScriptLoaderProps> = (props) => {
	const {
		onLoad = () => undefined,
		onError = () => undefined,
		...filteredProps
	} = props;
	const apiKey = process.env.REACT_APP_GOOGLE_API_KEY || '';

	return (
		<Script
			{...filteredProps}
			onLoad={onLoad}
			onError={onError}
			url={`https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`}
		/>
	);
};
